import React from "react"

const SkeletonLoader = ({ data, type }) => {
  return (
    <>
      {Object.keys(data).map(id => (
        <React.Fragment key={`skeleton-${id}`}>
          {!data[id].hidden && (
            <div
              className={`col-12 col-sm-6 ${
                type === "merchandise" ||
                type === "supplements" ||
                type === "meal plan"
                  ? "col-lg-4 col-xl-3"
                  : "col-lg-4"
              } margin-responsive`}
            >
              <div className="skeleton">
                <div
                  className={`skeleton__img ${
                    type === "apparel" || type === "merchandise"
                      ? "skeleton__img--vertical"
                      : ""
                  }`}
                ></div>
                <div className="skeleton__title" />
                <div className="skeleton__text" />

                <div className="skeleton__buttons">
                  <div className="skeleton__btn"></div>
                  <div className="skeleton__link"></div>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  )
}
export default SkeletonLoader
